import React, { Component, ReactNode } from 'react';
import StructCreateComponent from './StructCreateComponent';
import StructPreviewComponent from './StructPreviewComponent';
import FormicaLabel from '../../custom/FormicaLabel';
import LanguageUtil from '../../../util/LanguageUtil';

class StructEditorComponent extends Component<Props> {
  public render(): ReactNode {
    const { preview, prepare } = this.props;
    return (
      <div className={'flex w-full h-full py-5 gap-x-8 px-5'}>
        <div className={'flex flex-col w-full h-full'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'pages.struct.editor.create', defaultMessage: 'Create Struct' })} />
          <div className={'flex flex-col px-5 py-5 gap-y-5 border rounded-[12px]'}>
            <div className={'flex flex-col w-full  overflow-y-scroll h-[calc(100vh-380px)] bg-[#FCFCFC] py-3'}>
              <StructCreateComponent prepare={prepare} />
            </div>
          </div>
        </div>

        <div className={'flex flex-col w-full h-full'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'pages.struct.editor.jsonPreview', defaultMessage: 'JSON Preview' })} />
          <div className={'flex flex-col h-full px-5 py-5 gap-y-5 border rounded-[12px]'}>
            <div className={'flex flex-col w-full bg-[#FCFCFC] border-[0.5px] border-[#FCFCFC] h-[calc(100vh-380px)]'}>
              <StructPreviewComponent preview={preview} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

interface Props {
  preview: Record<string, any>;
  prepare: VoidFunction;
}

export default StructEditorComponent;
